/**
 * 通用列表列设置接口
 */
import { apiGet, apiPut } from '@/utils/request';

/** 列表类型标识枚举，用于 list_type 参数 */
export const LIST_TYPE = {
  CHAT_RECORDS: 'chat_records',
  DOUYIN_AUTH: 'douyin_auth',
  XIAOHONGSHU_AUTH: 'xiaohongshu_auth',
  WECHAT_OFFICIAL_AUTH: 'wechat_official_auth',
  WECHAT_SERVICE_AUTH: 'wechat_service_auth',
  QYWX_AUTH: 'qywx_auth',
  DY_FEIGE_AUTH: 'dy_feige_auth',
  TENCENT_CONSULTATION: 'tencent_consultation',
  KUAISHOU_AUTH: 'kuaishou_auth',
  BAIDU_MARKETING: 'baidu_marketing',
  WEBSITE_CONSULTATION: 'website_consultation',
  PUSH_GROUP: 'push_group',
  PUSH_API: 'push_api',
  QYWX_MOMENT_PLANS: 'qywx_moment_plans',
  ROBOT_WAKE: 'robot_wake',
  ROBOT_QA: 'robot_qa',
  ROBOT_KNOWLEDGE: 'robot_knowledge',
  ROBOT_GREETING: 'robot_greeting',
  ROBOT_COMMENT: 'robot_comment',
  ROBOT_COLLECT: 'robot_collect',
  TAGS: 'tags',
  AGENTS: 'agents',
  AGENT_PERSONNEL: 'agent_personnel',
  MATERIALS: 'materials',
  OPERATION_LOG: 'operation_log',
  CUSTOMER_REPORTING: 'customer_reporting',
  CUSTOMER_REPORTING_DOUYIN: 'customer_reporting_douyin',
  CUSTOMER_REPORTING_KUAISHOU: 'customer_reporting_kuaishou',
  MANUAL_REPLY: 'manual_reply',
  AD_REPORTING: 'ad_reporting',
  AD_REPORTING_DOUYIN: 'ad_reporting_douyin',
  AD_REPORTING_KUAISHOU: 'ad_reporting_kuaishou',
  BATCH_REACH: 'batch_reach',
  REACH_PLANS: 'reach_plans',
} as const;

export type ListType = (typeof LIST_TYPE)[keyof typeof LIST_TYPE];

/** 列配置项 */
export interface ColumnSettingItem {
  /** 列字段标识 */
  key: string;
  /** 是否显示该列，1 显示 0 隐藏 */
  visible: 0 | 1;
  /** 列排序序号，从 0 开始 */
  order: number;
  /** 固定列位置，可选 left、right */
  fixed?: 'left' | 'right' | null;
}

/** 获取列设置响应 data GET /api/column-settings */
export interface ColumnSettingsResponse {
  /** 列表类型标识 */
  list_type: string;
  /** 列配置列表 */
  columns: ColumnSettingItem[];
}

/** 更新列设置请求体 PUT /api/column-settings */
export interface ColumnSettingsUpdateBody {
  columns: ColumnSettingItem[];
}

export const columnSettingsApi = {
  /** 获取列设置 GET /api/column-settings?list_type=xxx */
  get: (list_type: string) =>
    apiGet<ColumnSettingsResponse>(`/column-settings?list_type=${list_type}`),
  /** 更新列设置 PUT /api/column-settings?list_type=xxx */
  update: (list_type: string, body: ColumnSettingsUpdateBody) =>
    apiPut(`/column-settings?list_type=${list_type}`, body),
};
